/* eslint-disable */

// assets
import { IconUserCircle } from '@tabler/icons';

// constant
const icons = {
    IconUserCircle
};
// Function to get title based on condition
const getTitle = (defaultTitle, bcTitle) => {
    const isBCWalletTrue = localStorage.getItem('bcWalletSuperDist'); // Check localStorage at runtime
    return isBCWalletTrue === 'true' ? defaultTitle : bcTitle;
};
const getTitleLabel2 = () => {
    const label2 = localStorage.getItem('label2');
    return label2;
};
const getTitleLabel3 = () => {
    const label3 = localStorage.getItem('label3');
    return label3;
};
// ==============================|| UTILITIES MENU ITEMS ||============================== //

const Dashboard = {
    id: 'newUtilities',
    // title: 'Super distributor',
    type: 'group',
    children: [
        // {
        //     id: 'icons1',
        //     title: 'Super Distributor',
        //     type: 'collapse',
        //     icon: icons.IconUserCircle,
        //     children: [
        {
            id: 'tabler-icons1126340033',
            title: 'Dashboard',
            type: 'item',
            url: 'middleManagerDashboard/dashboard',
            breadcrumbs: true
        },
        {
            id: 'tabler-icons8711',
            title: getTitle('BC Dashboard', 'Convert As BC Agent'),
            type: 'item',
            url: 'middleManagerDashboard/bc-dashboard-redirection',
            breadcrumbs: true
        },
        {
            id: 'icons2231434444222',
            title: 'Super Distributor',
            type: 'collapse',
            children: [
                {
                    id: 'tabler-icons312441032107009',
                    title: 'Add',
                    type: 'item',
                    url: 'middleManagerDashboard/addsuperdistributor',
                    breadcrumbs: true
                },
                {
                    id: 'tabler-icons5322141030220675',
                    title: 'List',
                    type: 'item',
                    url: '/middleManagerDashboard/listsuperdistributor',
                    breadcrumbs: false
                }
            ]
        },
        {
            id: 'icons2231344227',
            title: 'Distributor',
            type: 'collapse',
            children: [
                {
                    id: 'tabler-icons53224112289001',
                    title: 'Add',
                    type: 'item',
                    url: '/middleManagerDashboard/adddistributor',
                    breadcrumbs: false
                },
                {
                    id: 'tabler-icons53222118144129',
                    title: 'List',
                    type: 'item',
                    url: '/middleManagerDashboard/listdistributor',
                    breadcrumbs: false
                }
            ]
        },
        {
            id: 'icons223001333223',
            title: 'Manager',
            type: 'collapse',
            children: [
                {
                    id: 'tabler-icons31023314013',
                    title: 'Add',
                    type: 'item',
                    url: 'middleManagerDashboard/addmanager',
                    breadcrumbs: true
                },
                {
                    id: 'tabler-icons53221103234',
                    title: 'List',
                    type: 'item',
                    url: '/middleManagerDashboard/listmanager',
                    breadcrumbs: false
                }
            ]
        },
        {
            id: 'icons223120355332',
            title: 'Csp/Sanchalak',
            type: 'collapse',
            children: [
                {
                    id: 'tabler-icons31210401220',
                    title: 'Add',
                    type: 'item',
                    url: 'middleManagerDashboard/addcsp',
                    breadcrumbs: true
                },
                {
                    id: 'tabler-icons532201154222',
                    title: 'List',
                    type: 'item',
                    url: '/middleManagerDashboard/listcsp',
                    breadcrumbs: false
                }
            ]
        },
        {
            id: 'icons22312325644',
            title: 'Merchant',
            type: 'collapse',
            children: [
                {
                    id: 'tabler-icons53224110309',
                    title: 'List',
                    type: 'item',
                    url: '/middleManagerDashboard/listmerchant',
                    breadcrumbs: false
                }
            ]
        },
        {
            id: 'PVmonitoryMM',
            title: 'P V Monitor',
            type: 'item',
            url: 'middleManagerDashboard/physical-verification-monitor',
            breadcrumbs: true
        },
        {
            id: 'tabler-icons030133554',
            title: 'Daily Sales Monitoring',
            type: 'item',
            url: 'middleManagerDashboard/dailySalesMonitoring',
            breadcrumbs: true
        },
        {
            id: 'icons22312243322',
            title: 'Merchant Txn Track',
            type: 'collapse',
            children: [
                {
                    id: 'tabler-icons3121031142',
                    title: 'POS',
                    type: 'item',
                    url: 'middleManagerDashboard/posTxnTrack',
                    breadcrumbs: true
                },
                {
                    id: 'tabler-icons533422111',
                    title: 'QR',
                    type: 'item',
                    url: '/middleManagerDashboard/qrTxnTrack',
                    breadcrumbs: false
                }
            ]
        },
        {
            id: 'icons223124235367',
            title: 'BC Txn Track',
            type: 'collapse',
            children: [
                {
                    id: 'tabler-icons31214301009',
                    title: 'DMT',
                    type: 'item',
                    url: 'middleManagerDashboard/dmtTxnTrack',
                    breadcrumbs: true
                },
                {
                    id: 'tabler-icons53224113008',
                    title: 'BBPS',
                    type: 'item',
                    url: '/middleManagerDashboard/bbpsTxnTrack',
                    breadcrumbs: false
                },
                {
                    id: 'tabler-icons53221341001',
                    title: 'RECHARGE',
                    type: 'item',
                    url: '/middleManagerDashboard/rechargeTxnTrack',
                    breadcrumbs: false
                },
                {
                    id: 'tabler-icons53224311002',
                    title: 'MATM',
                    type: 'item',
                    url: '/middleManagerDashboard/matmTxnTrack',
                    breadcrumbs: false
                },
                {
                    id: 'tabler-icons53322110403',
                    title: 'AEPS',
                    type: 'item',
                    url: '/middleManagerDashboard/aepsTxnTrack',
                    breadcrumbs: false
                }
            ]
        },
        {
            id: 'tabler-icons11263400133',
            title: 'Rental Request List',
            type: 'item',
            url: 'middleManagerDashboard/device-approval',
            breadcrumbs: true
        },
        {
            id: 'tabler-icons0310133551',
            title: 'Device Request',
            type: 'item',
            url: 'middleManagerDashboard/device-request',
            breadcrumbs: true
        }
    ]
};

export default Dashboard;
